import resourcesEn from "./namespace/en/resource.json";
import resourcesEs from "./namespace/es/resource.json";
import resourcesJp from "./namespace/ja/resource.json";
import resourcesKo from "./namespace/ko/resource.json";
import resourcesZhCn from "./namespace/zh_cn/resource.json";
import resourcesZhTw from "./namespace/zh_tw/resource.json";

const resources = {
  en: {
    translation: resourcesEn,
  },
  es: {
    translation: resourcesEs,
  },
  ja: {
    translation: resourcesJp,
  },
  ko: {
    translation: resourcesKo,
  },
  zh_cn: {
    translation: resourcesZhCn,
  },
  zh_tw: {
    translation: resourcesZhTw,
  },
};

export default resources;
